import { BaseService } from './base';
import { ServiceAssociation } from '../models/serviceAssociation';

/**
 * Stub service for ServiceAssociation model registration.
 * CRUD operations are managed through ServiceService
 * (addAssociation, updateAssociation, removeAssociation).
 */
export class ServiceAssociationService extends BaseService<ServiceAssociation> {
  override model = ServiceAssociation;
  override modelName = 'serviceAssociation';
  override modelLabel = 'Service Association';
}
